import {
  TextareaHTMLAttributes,
  FocusEvent,
  ChangeEvent,
  useState,
} from 'react'
import cx from 'classnames'

import { CustomFormRegister } from './input-field'

interface TextAreaProps {
  formRegister: CustomFormRegister
  errorMessage?: string
  label?: string
  isInvertedColors?: boolean
}

const TextArea = ({
  id,
  value,
  defaultValue = '',
  autoComplete,
  placeholder,
  className,
  label,
  errorMessage,
  formRegister,
  isInvertedColors,
}: TextAreaProps & TextareaHTMLAttributes<HTMLTextAreaElement>) => {
  const isManaged = typeof value !== 'undefined'
  const [currentValue, setCurrentValue] = useState(defaultValue)

  return (
    <div className={cx('grid', className)}>
      <div className={cx('flex flex-col relative text-left')}>
        {label && (
          <label htmlFor={id} className="text-xs mb-2">
            {label}
          </label>
        )}

        <textarea
          id={id}
          inputMode="text"
          autoComplete={autoComplete}
          ref={formRegister.ref}
          name={formRegister.name}
          value={isManaged ? value : currentValue}
          placeholder={placeholder}
          onBlur={(event: FocusEvent<HTMLTextAreaElement>) => {
            formRegister.onBlur(event)
            setCurrentValue(event.target.value)
          }}
          onChange={(event: ChangeEvent<HTMLTextAreaElement>) => {
            formRegister.onChange(event)
            setCurrentValue(event.target.value)
          }}
          className={cx(
            'relative appearance-none w-full h-full py-4 border px-4',
            'text-base leading-none',
            {
              'bg-input-bg text-input-text placeholder-input-placeholder':
                !isInvertedColors,
              'bg-input-inverted-bg text-input-inverted-text placeholder-input-inverted-placeholder':
                isInvertedColors,
              'border-error': errorMessage,
              'border-input-border': !errorMessage && !isInvertedColors,
              'border-input-inverted-border': !errorMessage && isInvertedColors,
            }
          )}
        >
          {value}
        </textarea>

        {errorMessage && (
          <span role="alert" className="mt-2 text-xs text-error">
            {errorMessage}
          </span>
        )}
      </div>
    </div>
  )
}

export default TextArea
